import {useTranslation} from 'react-i18next';
import {useFormContext, Controller} from 'react-hook-form';
import {Validators} from '@chekin/api';
import PhoneInputComponent from 'components/common/PhoneInput';
import {StyledFormFieldWrapper} from './styled';

interface PhoneInputProps {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
}

const PhoneInput = ({
  name,
  label,
  disabled = false,
  required = false,
}: PhoneInputProps) => {
  const {t} = useTranslation();
  const {control} = useFormContext();

  return (
    <StyledFormFieldWrapper>
      <Controller
        name={name}
        rules={{
          required: required ? t('phone_required') : false,
          validate: {
            valid: Validators.phoneValidateService,
          },
        }}
        control={control}
        render={({field: {onBlur, onChange, ...restField}, fieldState: {error}}) => (
          <PhoneInputComponent
            label={label}
            error={error?.message}
            onBlur={onBlur}
            onChange={(_, __, details) => onChange(details)}
            disabled={disabled}
            {...restField}
          />
        )}
      />
    </StyledFormFieldWrapper>
  );
};

export {PhoneInput};
